import { map } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable,ReplaySubject } from 'rxjs';
import { Component, Inject, OnInit, ViewChild } from "@angular/core";

import { AppService } from "src/app/app.service";
import { LoginserviceService } from "src/app/services/loginservice.service";
import { Router } from "@angular/router";
import { ConstatService } from "src/app/services/constat.service";
import { VehiculeserviceService } from "src/app/services/vehiculeservice.service";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from 'ngx-spinner';
import { StepperOrientation } from '@angular/cdk/stepper';
import { RentingService } from 'src/app/services/renting.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgSignaturePadOptions, SignaturePadComponent } from '@almothafar/angular-signature-pad';

type Constat = Array<{id:number,name:string,file:File[], fileBase64:any[];commentValue:string,valided:boolean}>
type detailConstat = Array<{ elementConstatId: number;fileBase64:any[],commentaire:string}>;

@Component({
  selector: "app-addconstat",
  templateUrl: "./addconstat.component.html",
  styleUrls: ["./addconstat.component.scss"],
})
export class AddconstatComponent implements OnInit {

  constat:Constat=[];
  vehicule:number;
  detailConstat:detailConstat=[];
  totalElementConstat:number;
  public userIn: any;
  public Car: any;
  stepperOrientation: Observable<StepperOrientation>;
  stepperOrientationMain: Observable<StepperOrientation>;
  resposive:string;
  rentings:Array<any>=[];
  renting:any;

  @ViewChild('signature')
  public signaturePad: SignaturePadComponent;

  public signaturePadOptions: NgSignaturePadOptions = { // passed through to szimek/signature_pad constructor
    minWidth: 5,
    canvasWidth: 500,
    canvasHeight: 300
  };

  signatureImg: string|null;

  showMessage=false;

  constructor(
    public appService: AppService,
    public loginService: LoginserviceService,
    public constatService: ConstatService,
    public router: Router,
    public carservice: VehiculeserviceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private rentingService: RentingService,
    public dialog: MatDialog
  ) {

    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({matches}) => (matches ? 'horizontal' : 'vertical')));
    
      this.stepperOrientation.subscribe((data)=>{
        this.resposive=data;
      })
      this.stepperOrientationMain = breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({matches}) => (matches ? 'vertical' : 'horizontal')));
  }

  ngOnInit() {
    this.getCar();
  }

  ngAfterViewInit() {
    // this.signaturePad is now available
    this.signaturePad.set('minWidth', 5); // set szimek/signature_pad options at runtime
    this.cleanSignature(); // invoke functions from szimek/signature_pad API
  }

  drawComplete(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onEnd event
    console.log('Completed drawing', event);
    console.log(this.signaturePad.toDataURL());

    const base64Data = this.signaturePad.toDataURL();
    this.signatureImg = base64Data;
  }

  cleanSignature()
  {
    this.signaturePad.clear();
    this.signatureImg = null;
  }

  drawStart(event: MouseEvent | Touch) {
    // will be notified of szimek/signature_pad's onBegin event
    console.log('Start drawing', event);
  }

  public getCar() {
    const storage = localStorage.getItem("facebook_auth");
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    }

    if (storage) {
      this.userIn = JSON.parse(storage);
    }

    this.carservice.getvehicleConstat(this.userIn.id).subscribe((data: any) => {
      console.log(data);
      this.Car = data.vehicules;
    });
  }

  resevationVehicule()
  {
    this.renting=null;
    this.constat=[];
    this.totalElementConstat=this.totalElementConstat!=null || this.totalElementConstat!=undefined? 0:this.totalElementConstat;

    let vehicule = this.Car.find((elt:any)=>elt.id==this.vehicule);
    this.rentings= vehicule.rentings;
  }

  loadElementConstat()
  {
    if(this.renting !=null && this.renting!=undefined)
    {
      this.constatService.elemtnConstat().subscribe((response:any)=>{
        this.constat=response;
        this.totalElementConstat=this.constat.length;
        console.log( this.totalElementConstat);
      });
    }
  }

  onSelect(event:any,i:any) {
    this.showMessage=true;
    this.constat[i].file.push(...event.addedFiles);
    setTimeout(() => {
       
      if(event.rejectedFiles.length >0)
      {
        this.toastr.error('Assurez vous d\'avoir Selectionner une image inférieur ou égale à la taille recommandée', 'Erreur !', {
          timeOut: 5000,
        });
      }
      if(this.constat[i].file.length!=0 && !this.constat[i].valided)
      {
        this.constat[i].valided=true;
        this.totalElementConstat-=1;
       
      }
      console.log(this.totalElementConstat);
      this.constat[i].file.forEach(elt=>{
        this.convertFile(elt).subscribe(base64 => {
          this.constat[i].fileBase64.push({name:elt.name,image:"data:"+elt.type+";base64,"+base64});
        });
      })
    }, 2000,);

    
    //if(!interval)this.showMessage=false
  }

  onCheckFile(i:any)
  {
      if( this.constat[i].file.length==0)
      {
        return true
      }
      return false;
  }

  onRemove(event:any,i:any) {
    this.constat[i].file.splice(this.constat[i].file.indexOf(event), 1);
    if(this.constat[i].file.length==0 && this.constat[i].valided)
    {
      this.constat[i].valided=false;
      this.totalElementConstat+=1;
    }
  }

  onRemoveAll(i:any){
    this.constat[i].file=[];
    if(this.constat[i].valided)
    {
      this.constat[i].valided=false;
      this.totalElementConstat+=1;
    }
  }

  seeFile(event:any,i:any)
  {
    let indexFile:any=this.constat[i].file.indexOf(event);
    let file:any= this.constat[i].file[indexFile];

    const dialogRef = this.dialog.open(ShowFileConstatComponent, {
      width: '780px',
      height:'500px',
      data: {file: file},
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //this.animal = result;
    });
    console.log(file);
  }

  onSubmitConstat()
  {
    this.detailConstat=[];
    this.spinner.show();
      const storageAuth = localStorage.getItem("user");
      if (storageAuth) {
        this.userIn = JSON.parse(storageAuth);
      }

      const decla_id= this.userIn.id;

    if(!this.checkAllfileConstat() || this.vehicule==null || this.renting ==null)
    {
      //this.spinner.hide();
      this.toastr.error('Assurez vous d\'avoir remplis tout les champs obligatoires', 'Erreur !', {
        timeOut: 3000,
      });
    }
    else
    {
      for (let i = 0; i <  this.constat.length; i++) {
        this.detailConstat.push({
          elementConstatId:this.constat[i].id,
          commentaire:this.constat[i].commentValue,
          fileBase64:this.constat[i].fileBase64
        })
      }
      let constatdata={
        vehicleId:this.vehicule,
        declarantId:decla_id,
        locataireId:this.renting.loc_id,
        rentingId:this.renting.id,
        detailConstat:this.detailConstat,
        signature:this.signatureImg
      }

      console.log(constatdata);
      this.constatService.addconstat(constatdata).subscribe((data:any) => {
        if(data.status !=0)
        {
          this.spinner.hide();
          this.toastr.success('le constat crée avec succes ');
          this.router.navigateByUrl('/compte-utilisateur/constat').then();
        }
        else{
          this.toastr.warning(data.message);
          this.spinner.hide();
        }
      },error=>{
        this.spinner.hide();
        console.log(error);
      });
    }
  }
  annuler()
  {
    this.router.navigateByUrl('/compte-utilisateur/constat').then();
  }
  checkAllfileConstat()
  {
    if(this.constat !=null)
    {
      this.constat.forEach(elt=>{
        if(elt.file.length!=0 && !elt.valided)
        {
          elt.valided=true;
          this.totalElementConstat-=1;
        }

      })
      return this.totalElementConstat == 0?true:false;  
    }
    else{
      return false;
    }
   
  }

  changeFile(e:any)
  {
    let data:any=[];
    this.convertFile(e.target.files[0]).subscribe(base64 => {
      data.push({image:base64});
      this.constatService.addconstat({files:data}).subscribe((data) => {
        console.log(data);
      },error=>{
        console.log(error);
      });
    }); 
  }

  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event:any) => result.next(btoa(event.target.result.toString()));
    return result;
  }

  voirContrat(){
    let data = this.Car.find((elt:any)=>elt.id==this.vehicule)
    let renting = data.rentings.find((elt:any)=>elt.id==this.renting.id)
    const dialogRef = this.dialog.open(ShowContratComponent, {
      width: '780px',
      height:'780px',
      data: {vehicule: data,renting:renting},
    });
  }
}


@Component({
  selector: 'app-show-file-constat',
  templateUrl: 'show-file-constat.component.html',
})
export class ShowFileConstatComponent implements OnInit {
  imageSrc: string;
  constructor(
    public dialogRef: MatDialogRef<ShowFileConstatComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    //console.log(this.data);   
    this.onFileChange(this.data.file)
  }

  onFileChange(fileImage:File) {

    const reader = new FileReader();

    if(typeof fileImage =="string")
    {
      this.imageSrc = fileImage;
    }
    else{
       //const [file] = fileImage;
       reader.readAsDataURL(fileImage);
       reader.onload = () => {
         this.imageSrc = reader.result as string;
       };
    }
   
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}

@Component({
  selector: 'app-show-contrat',
  templateUrl: 'show-contrat.component.html',
})

export class ShowContratComponent implements OnInit{

  vehicule:any=null;
  renting:any=null;
  icon:string='./assets/images/logo/logo.png'
  constructor(
    public dialogRef: MatDialogRef<ShowContratComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ){}

  ngOnInit(): void {
    this.vehicule= this.data.vehicule;
    this.renting = this.data.renting
  }
  close()
  {
    this.dialogRef.close();
  }
}